export const ticketColumnConfig = [
  {
    title: 'Ticket No.',
    dataIndex: 'ticketNo',
    // key: 'ticketNo',
  },
  {
    title: 'Requested By',
    dataIndex: 'requestBy',
    width: '8.125rem',
  },
  {
    title: 'Project Name',
    dataIndex: 'relatedItem',
  },
  {
    title: 'Connected Page',
    dataIndex: 'connectedPage',
    width: '8.125rem',
    // key: 'address',
  },
  {
    title: 'Category',
    dataIndex: 'category',
    width: '11.25rem',
    // key: 'address',
  },
  {
    title: 'Description',
    dataIndex: 'decription',
    // key: 'address',
    width: '9.375rem',
  },
  {
    title: 'Follow Up',
    dataIndex: 'followUp',
    align: 'center',
    // key: 'address',
  },
  {
    title: 'Resolved',
    dataIndex: 'resolved',
    align: 'center',
    // key: 'address',
  },
  {
    title: 'Created Date',
    dataIndex: 'createdDate',
    // key: 'address',
  },
  {
    title: 'Assigned To',
    dataIndex: 'assignedTo',
    // key: 'address',
  },
];
